import { useCallback } from "react";
import { getFilterOptions } from "../api/reports";
import type { FilterValues, ReportFilter } from "../api/types";
import { RuntimeFilters } from "./RuntimeFilters";

interface ReportFiltersProps {
  reportId: number;
  filters: ReportFilter[];
  values: FilterValues;
  onChange: (filterId: string, values: string[]) => void;
}

// Report-specific adapter around the shared runtime filter controls.
export function ReportFilters({
  reportId,
  filters,
  values,
  onChange,
}: ReportFiltersProps) {
  const loadOptions = useCallback(
    (filterId: string) => getFilterOptions(reportId, filterId),
    [reportId],
  );

  return (
    <RuntimeFilters
      optionsScope={`report:${reportId}`}
      filters={filters}
      values={values}
      onChange={onChange}
      loadOptions={loadOptions}
    />
  );
}
